import { render, staticRenderFns } from "./TipsButton.vue?vue&type=template&id=4993f380&scoped=true&"
import script from "./TipsButton.vue?vue&type=script&lang=js&"
export * from "./TipsButton.vue?vue&type=script&lang=js&"
import style0 from "./TipsButton.vue?vue&type=style&index=0&id=4993f380&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993f380",
  null
  
)

export default component.exports